// src/components/EmailHint.jsx
// Eén regel onder het e-mailveld: "Bedoelt u jan@gmail.com?". Rendert niets zonder voorstel
// (conditioneel renderen, geen hidden/display — zie keukeninbeeld-les).
import React from 'react';

export default function EmailHint({ suggestion, onApply }) {
  if (!suggestion) return null;
  return (
    <p className="text-sm text-slate-600 mt-1.5" role="status">
      Bedoelt u{' '}
      <button type="button" onClick={onApply} className="font-semibold text-blue-700 underline">
        {suggestion}
      </button>
      ?
    </p>
  );
}
